const extractStacklineSkus = (message) => {
    var _a;
    const products = message.match(/<product stacklineSku="([^"]+)">([^<]+)<\/product>/g);
    return ((_a = products === null || products === void 0 ? void 0 : products.map((product) => product.split('</product>')[0].split('<product stacklineSku=')[1].split('>')[0].replace(/"/g, ''))) !== null && _a !== void 0 ? _a : []);
};
const extractInnerTextFromProductTag = (message) => {
    const match = message.match(/<product stacklineSku="[^"]+">([^<]+)<\/product>/);
    return match ? match[1] : '';
};
const extractProductsWithText = (message) => {
    // Updated regex to handle both <product stacklineSku="ABC"></product> and <product stacklineSku="ABC">Text</product>
    const regex = /<product stacklineSku="([^"]+)">([^<]*)<\/product>/g;
    const products = [];
    let match;
    while ((match = regex.exec(message)) !== null) {
        products.push({
            stacklineSku: match[1],
            innerText: match[2], // Can be empty string now
        });
    }
    return products;
};
const extractProductsByHeading = (message) => {
    const lines = message.split('\n');
    const result = {};
    let currentHeading = 'uncategorized';
    for (const line of lines) {
        // Check if line is a markdown heading (# or ## or ### heading)
        const headingMatch = line.match(/^#{1,3}\s+(.+)$/);
        if (headingMatch) {
            currentHeading = headingMatch[1].trim();
            result[currentHeading] = [];
            continue;
        }
        // Check if line contains a product
        const productMatch = line.match(/<product stacklineSku="([^"]+)">([^<]+)<\/product>/);
        if (productMatch) {
            if (!result[currentHeading]) {
                result[currentHeading] = [];
            }
            result[currentHeading].push({
                stacklineSku: productMatch[1],
                innerText: productMatch[2],
            });
        }
    }
    return result;
};
const extractProductGroups = (message) => {
    const regex = /<product_group>([\s\S]*?)<\/product_group>/g;
    const groups = [];
    let match;
    while ((match = regex.exec(message)) !== null) {
        const fullMatch = match[0];
        const groupContent = match[1];
        const startIndex = match.index;
        const endIndex = match.index + fullMatch.length;
        // Extract products from within this group
        const products = extractProductsWithText(groupContent);
        groups.push({
            fullMatch,
            startIndex,
            endIndex,
            products,
        });
    }
    return groups;
};

export { extractInnerTextFromProductTag, extractProductGroups, extractProductsByHeading, extractProductsWithText, extractStacklineSkus };
//# sourceMappingURL=StringUtils.js.map
